export const API_URL = "https://forkify-api.jonas.io/api/v2/recipes";
export const API_KEY = "28f8c300-b2ac-42ef-b728-82b5103aa1d9";
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const MODAL_CLOSE_SEC = 2.5;
